import React, {PropsWithChildren, useCallback, useEffect} from "react";
import GlobalNavBar from "@/components/header/GlobalNavBar";
import NavRail from "@/components/navigation/NavRail";
import {Header, LeftAside, Main, PageNav, Wrapper} from "@/components/Layout.styles";
import {useRosterStore} from "@/store/roster_store";
import {useAlertStore} from "@/store/alert_store";
import ToastNotification from "patient-ping-remedy/packages/toast";
import {useLocation} from "react-router-dom";
import PageHeader from "@common/pages/PageHeader";
import {PageTitleProvider} from "@/hooks/useBreadcrumbs";

export default function Layout(props: PropsWithChildren) {
  const { currentRoster, setCurrentRoster, selectedRoster, setSelectedRoster } = useRosterStore();
  const { alerts, setAlerts } = useAlertStore();
  const location = useLocation();

  const isFacilityContext = useCallback(
    () => !/^\/(analytics|admin|settings|tools)(\/.*)?$/.test(location.pathname), [location.pathname]);

  const isTasksRoute = /^\/tasks(\/|$)/.test(location.pathname);
  const isAllGroupsRoute = /^\/(messages|notifications)(\/|$)/.test(location.pathname);

  useEffect(() => {
    if (!isFacilityContext() || isTasksRoute) {
      setCurrentRoster(null);
      return;
    }

    if (currentRoster) {
      setSelectedRoster(currentRoster);
    } else if (!isAllGroupsRoute && !isTasksRoute) {
      setCurrentRoster(selectedRoster);
    }
  }, [isFacilityContext, currentRoster, selectedRoster, isAllGroupsRoute, isTasksRoute]);

  return (
    <PageTitleProvider>
      <Wrapper>
        <Header>
          <GlobalNavBar isFacilityContext={isFacilityContext()} hideFacilityPicker={isTasksRoute} />
        </Header>
        <LeftAside>
          <NavRail />
        </LeftAside>
        <PageNav>
          <PageHeader />
        </PageNav>
        <Main>
          {props.children}
        </Main>
        <ToastNotification
          toasts={alerts.map((alert) => ({ ...alert, className: 'remedy-alert' }))}
          remove={(index) => setAlerts(alerts.filter((_, i) => i !== index))}
        />
      </Wrapper>
    </PageTitleProvider>
  );
}
